export default "__VITE_ASSET__Bg6bGBB8__"